import { useEffect } from 'react'
import { siteConfig } from '../config/site'

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    const [key, keyValue] = attribute
    element.setAttribute(key, keyValue)
    document.head.appendChild(element)
  }
  element.setAttribute('content', value)
}

export function Seo({ title, description = siteConfig.description, path = '/', noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${siteConfig.name}` : siteConfig.name
    const canonicalUrl = new URL(path, siteConfig.domain).toString()
    const socialImage = new URL(siteConfig.logoPath, siteConfig.domain).toString()

    document.title = fullTitle
    setMeta('meta[name="description"]', ['name', 'description'], description)
    setMeta('meta[name="robots"]', ['name', 'robots'], noindex ? 'noindex, nofollow' : 'index, follow')
    setMeta('meta[property="og:title"]', ['property', 'og:title'], fullTitle)
    setMeta('meta[property="og:description"]', ['property', 'og:description'], description)
    setMeta('meta[property="og:url"]', ['property', 'og:url'], canonicalUrl)
    setMeta('meta[property="og:image"]', ['property', 'og:image'], socialImage)
    setMeta('meta[property="og:image:alt"]', ['property', 'og:image:alt'], `${siteConfig.name} official logo`)
    setMeta('meta[name="twitter:title"]', ['name', 'twitter:title'], fullTitle)
    setMeta('meta[name="twitter:description"]', ['name', 'twitter:description'], description)
    setMeta('meta[name="twitter:image"]', ['name', 'twitter:image'], socialImage)

    const canonical = document.head.querySelector('link[rel="canonical"]')
    canonical?.setAttribute('href', canonicalUrl)
  }, [description, noindex, path, title])

  return null
}
